export const CheckoutSteps = {
    CALENDAR: "calendar",
    TICKETS: "tickets",
    REGISTER: "register",
    ADDONS: "addons",
    RECEIPT: "autumn",
}